import { router } from '@inertiajs/vue3';
import { onMounted, onUnmounted } from 'vue';

export function useGlobalAuthCheck() {
    const checkAuthState = () => {
        router.reload({ only: ['auth'] });
    };

    const handleVisibilityChange = () => {
        if (!document.hidden) checkAuthState();
    };

    const handleWindowFocus = () => {
        checkAuthState();
    };

    onMounted(() => {
        document.addEventListener('visibilitychange', handleVisibilityChange);
        window.addEventListener('focus', handleWindowFocus);
    });

    onUnmounted(() => {
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        window.removeEventListener('focus', handleWindowFocus);
    });
}
